import { getVariantItemImageUrl } from "./get-product-image-url.js";
const groupByFacetTerm = (variants, facetKey) => {
  const facetTermMap = /* @__PURE__ */ new Map();
  for (const variant of variants) {
    const term = variant.facets[facetKey] || null;
    const variantGroup = facetTermMap.get(term) || [];
    variantGroup.push(variant);
    facetTermMap.set(term, variantGroup);
  }
  return facetTermMap;
};
const buildTree = (facetConfigList, variants, facetConfigIndex) => {
  if (facetConfigIndex >= facetConfigList.length) return [];
  const currentFacetConfig = facetConfigList[facetConfigIndex];
  if (!currentFacetConfig) return [];
  const facetTermMap = groupByFacetTerm(variants, currentFacetConfig.facetKey);
  const tree = Array.from(facetTermMap, ([facetTerm, variantGroup]) => {
    const firstVariant = variantGroup[0];
    if (!firstVariant) {
      throw new Error(
        `Something went wrong while building the variant facet tree for facetTerm: ${facetTerm}`
      );
    }
    const skuCollection = variantGroup.map((v) => v.sku);
    const childFacets = buildTree(facetConfigList, variantGroup, facetConfigIndex + 1);
    const hasNoChildFacetTerms = childFacets.length === 0 || childFacets.every((facet) => facet.facetTerm === null);
    if (hasNoChildFacetTerms && skuCollection.length > 1) {
      return variantGroup.map((variant) => {
        const degroupedFacetTerm = variant.facets[currentFacetConfig.facetKey] || null;
        return createFacetNode({
          variant,
          facetKey: currentFacetConfig.facetKey,
          facetTerm: degroupedFacetTerm,
          childFacets: [],
          skuCollection: [variant.sku]
        });
      });
    }
    const facetNode = createFacetNode({
      variant: firstVariant,
      facetKey: currentFacetConfig.facetKey,
      facetTerm,
      childFacets,
      skuCollection
    });
    return [facetNode];
  }).flat();
  if (currentFacetConfig.sortCompareFunction) {
    tree.sort(currentFacetConfig.sortCompareFunction);
  }
  return tree;
};
const createFacetNode = ({
  variant,
  facetKey,
  facetTerm,
  childFacets,
  skuCollection
}) => {
  const { sku, slug, displayName, media } = variant;
  return {
    facetKey,
    facetTerm,
    childFacets,
    name: displayName,
    imageUrl: getVariantItemImageUrl(media),
    skuCollection,
    sku,
    slug
  };
};
const createVariantSelectorTree = (variants, facetConfigList) => {
  if (!facetConfigList.length) return [];
  const publishedVariants = variants.filter((variant) => variant.isPublished);
  return buildTree(facetConfigList, publishedVariants, 0);
};
export {
  createVariantSelectorTree
};
//# sourceMappingURL=create-variant-facet-tree.js.map
